<script>
export default {
  props: {
    pricingData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      revpayData: {}
    };
  },
  computed:{
    
  },
  methods: {
    async subscribe(item){
      let activeSubscription = localStorage.getItem('subscription')
      if(activeSubscription != 'null' && activeSubscription != 'undefined'){
        this.$swal({
          text: 'You already have active subscription',
          icon: 'warning'
        })

        return
      }

      await window.axios.post('/api/subscription/create-order-revpay-web', {
        package_id: item.id,
        amount: item.price
      }).then(res => {
        this.revpayData = res.data
        
      })

      this.$refs.revpayForm.submit()
    }
  }
};
</script>

<template>
  <div class="row">
    <div
      class="col-md-4 col-12 mt-4 pt-2"
      v-for="(item, index) of pricingData"
      :key="index"
    >
      <div
        class="card pricing-rates business-rate shadow bg-light rounded text-center border-0"
      >
        <div
          class="ribbon ribbon-right ribbon-warning overflow-hidden"
          v-if="item.isBest === true"
        >
          <span class="text-center d-block shadow small h6">Best</span>
        </div>

        <div class="card-body py-5">
          <h3 class="title font-weight-bold text-uppercase text-primary mb-4">
            {{ item.name }}
          </h3>
          <div class="d-flex justify-content-center mb-4">
            <span class="h4 mb-0 mt-2">RM</span>
            <span class="price h1 mb-0">{{ item.price }}</span>
          </div>

          <ul class="list-unstyled mb-0 pl-0">
            <li class="h6 text-muted mb-0">
              <span class="text-primary h5 mr-2">
                <i class="uil uil-check-circle align-middle"></i>
              </span>
              {{ (item.months_eligible == 12) ? '1 Year Access' : (item.months_eligible == 24) ? '2 Years Access' : (item.months_eligible == 36) ? '3 Years Access' : ''}}
            </li>
            <li class="h6 text-muted mb-0">
              <span class="text-primary h5 mr-2" v-if="item.type == 'All' || item.type == 'Sarawak Tribune'">
                <i class="uil uil-check-circle align-middle"></i>
              </span>
              Sarawak Tribune
            </li>
            <li class="h6 text-muted mb-0">
              <span class="text-primary h5 mr-2" v-if="item.type == 'All' || item.type == 'Suara Sarawak'">
                <i class="uil uil-check-circle align-middle"></i>
              </span>
              Suara Sarawak
            </li>
            <li class="h6 text-muted mb-0">             
              <span class="text-primary h5 mr-2">
                <i class="uil uil-check-circle align-middle"></i>              
              </span>
              <span v-if="item.is_access_to_archive == 1">
                {{ (item.months_eligible == 12) ? '1 Years Archive' : (item.months_eligible == 24) ? '2 Years Archive' : (item.months_eligible == 36) ? '3 Years Archive' : ''}}
              </span>
              <span v-if="item.is_access_to_archive == 2">
                All Archive
              </span>
            </li>
          </ul>
          <a href="javascript:void(0)" class="btn btn-primary mt-4" @click="subscribe(item)">Subscribe Now</a>
        </div>
      </div>
    </div>
    
    <form ref="revpayForm" style="display: none" method="post" :action="revpayData.revpay_payment_url" accept-charset="UTF-8">
          <input type="text" name="Revpay_Merchant_ID" :value="revpayData.revpay_merchant_id"><br></br> <input type="text" name="Payment_ID" value="2"><br></br>
          <input type="text" name="Bank_Code" value=""><br></br>
          <input type="text" name="Reference_Number" :value="revpayData.reference_number"><br></br> <input type="text" name="Amount" :value="revpayData.amount"><br></br>
          <input type="text" name="Currency" value="MYR"><br></br>
          <input type="text" name="Transaction_Description" :value="revpayData.description"><br></br> <input type="text" name="Billing_Address" value=""><br></br>
          <input type="text" name="Shipping_Address" value=""><br></br>
          <input type="text" name="Device_ID" value=""><br></br>
          <input type="text" name="Ecomm_Marketplace" value=""><br></br>
          <input type="text" name="Promo_Code" value=""><br></br>
          <input type="text" name="Transaction_Type" value=""><br></br>
          <input type="text" name="Customer_ID" :value="revpayData.customer_id"><br></br>
          <input type="text" name="Customer_Name" :value="revpayData.customer_name"><br></br>
          <input type="text" name="Customer_Email" :value="revpayData.customer_email"><br></br>
          <input type="text" name="Customer_Contact" value=""><br></br>
          <input type="text" name="Customer_IP" :value="revpayData.customer_ip"><br></br>
          <input type="text" name="Geo_Location" value=""><br></br>
          <input type="text" name="Card_Type" value=""><br></br>
          <input type="text" name="Card_Holder_Name" value=""><br></br>
          <input type="text" name="Funding_Pan" value=""><br></br>
          <input type="text" name="Funding_Exp_Date" value=""><br></br>
          <input type="text" name="Funding_CVV" value=""><br></br>
          <input type="text" name="Card_Issuer_Bank_Country_Code" value=""><br></br>
          <input type="text" name="Installment_Plan" value=""><br></br>
          <input type="text" name="Installment_Term" value=""><br></br>
          <input type="text" name="Token_Pan" value=""><br></br>
          <input type="text" name="Token_Exp_Date" value=""><br></br>
          <input type="text" name="Key_Index" :value="revpayData.merchant_key_index"><br></br>
          <input type="text" name="Signature" :value="revpayData.signature"><br></br>
          <!-- <input type="text" name="Return_URL" :value="revpayData.return_url"><br></br> <input value="Submit" type="submit"> -->
          <input type="text" name="Return_URL" :value="revpayData.return_url"><br></br> <input value="Submit" type="submit">
        </form>

  </div>
</template>